import Typography from '@mui/material/Typography'
import { css, styled } from '@mui/material/styles'
import { colors } from '@theme/variables'

export const ProgressContainer = styled('div')`
  display: flex;

  ${({ $flexDirection }: { $flexDirection?: 'row' | 'column' }) =>
    css`
      flex-direction: ${$flexDirection};
      align-items: ${$flexDirection === 'column' ? 'start' : 'center'};
    `}
`

export const ProgressLabel = styled(Typography)`
  color: ${colors.pink};
  margin-right: 10px;
`
